import React, { useEffect } from 'react';
import { CContainer, CRow, CCol, CCard, CCardBody, CCardHeader, 
  CBreadcrumb, CBreadcrumbItem } from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import SupplierTypeInputs from '../../components/SupplierTypeInputs/SupplierTypeInputs';
import { updateSupplierTypeRequestAction } from '../../store/supplierType/supplierTypeActions';
import { useTranslation } from '../../hooks/useTranslation';

const UpdateSupplierType = ({ updateSupplierTypeRequest, isLoading, updateSupplierTypeData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();
  const supplierTypeData = location.state?.supplierType || null;

  useEffect(() => {
    if (!supplierTypeData && id) {
      console.warn('No supplier type data found in route state. You may need to fetch by ID:', 
      id);
    }
  }, [supplierTypeData, id]);

  const handleSubmit = (data) => {
    updateSupplierTypeRequest({
      data,
      navigate
    });
  };

  const handleCancel = () => {
    navigate('/suppliertype');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/suppliertype" onClick={(e) => { e.preventDefault();
           navigate('/suppliertype'); }}>
          {t('supplierType')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateSupplierType')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('updateSupplierType')}</h4></CCardHeader>
            <CCardBody>
              <SupplierTypeInputs
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isLoading={isLoading}
                submitResponse={updateSupplierTypeData}
                initialData={supplierTypeData}
                isEdit
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading
});

export default connect(mapStateToProps, { updateSupplierTypeRequest: 
  updateSupplierTypeRequestAction })(UpdateSupplierType);


